import { useDisclosure } from "@heroui/modal";
import { CircularProgress } from "@heroui/progress";
import React from "react";
import { SkillType } from "~/types/SkillLevel";
import { SkillDescriptionModal } from "./SkillDescriptionModal";
import { FaLock } from "react-icons/fa";

export const SkillLevelIndicator = ({
  icon,
  skill,
  practiceSkill,
  isComingSoon = false,
}: {
  icon: React.ReactNode;
  skill: SkillType;
  practiceSkill: (skillName?: SkillType["name"]) => void;
  isComingSoon?: boolean;
}) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  return (
    <button
      className="flex flex-col items-center justify-center"
      onClick={onOpen}
    >
      <SkillDescriptionModal
        skill={skill}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
        isComingSoon={isComingSoon}
        practiceSkill={practiceSkill}
      />
      <CircularProgress
        valueLabel={
          <div className="relative">
            {icon}
            <div className="absolute -bottom-1 font-chewy -right-5 border-background border bg-[#fda331] text-[#594833] text-lg flex flex-col justify-center items-center w-6 h-6 rounded-full">
              {isComingSoon ? (
                <FaLock className="text-xs" />
              ) : (
                <>{skill.level}</>
              )}
            </div>
          </div>
        }
        aria-label="Skill Level Indicator"
        value={skill.currentXP}
        maxValue={skill.nextLevelRequiredXP}
        minValue={skill.currentLevelRequiredXP}
        showValueLabel={true}
        classNames={{
          svg: "w-[110px] h-[110px] rotate-[135deg]",
          indicator: "stroke-warning stroke-[3] ",
          track: "stroke-black/10 dark:stroke-white/10 stroke-[3]",
        }}
      />

      <h1 className="text-xl text-white font-bangers">{skill.name}</h1>
    </button>
  );
};
